import { useQuery } from '@apollo/client';
import { IntegrationInstancesQuery } from './graphql';
import { IntegrationDefinition, IntegrationInstance } from './types';
import useIntegrationDefinitions from './useIntegrationDefinitions';

interface HookReturnValue {
  instances?: IntegrationInstance[];
  definitions?: IntegrationDefinition[];
  loading: boolean;
}

export default function useIntegrationInstancesAndDefinitions(): HookReturnValue {
  const { data, loading } = useQuery(IntegrationInstancesQuery);
  const {
    data: definitionsData,
    loading: definitionsLoading,
  } = useIntegrationDefinitions();
  const instances = data?.integrationInstances?.instances;
  const definitions = definitionsData?.integrationDefinitions?.definitions;
  return {
    loading: loading || definitionsLoading,
    instances,
    definitions,
  };
}
